var Modal = require("components/utility/AltModal");
var CoinDisplay = require("components/utility/CoinDisplay");
var Spinner = require("components/utility/Spinner");
var QuizAnalysisDisplay = require("components/writing/quizzes/QuizAnalysisDisplay");
var FeedbackFormatter = require("lib/interface/FeedbackFormatter");

var CurrentUser = require("lib/account/CurrentUser");

require("reading/shelves/coin_details_modal.scss");

class CoinDetailsModal extends React.Component {

	deFrame() {
		if ($('#bookDetailFrame').length > 0) {
			var frame = $('#bookDetailFrame')[0].firstChild
			$(frame).css('overflow','visible')
		}
	}
	reFrame() {
		if ($('#bookDetailFrame').length > 0) {
			var frame = $('#bookDetailFrame')[0].firstChild
			$(frame).css('overflow','scroll')
		}
	}
	show() {
		this.deFrame()
		this.refs.modal.show();
	}

	getShortReasonText(coinRecord) {
		if (!CurrentUser.isPremiumAccount()) {
			return "Completed Quiz";
		} else if (coinRecord.key == "passed-quiz") {
			return "Passed the quiz";
		} else if (coinRecord.key == "failed-quiz") {
			return "Took the quiz";
		} else if (coinRecord.key.includes("addressed-feedback")) {
			return "Listened to Owlfonso's advice";
		} else if (coinRecord.key == "journal-activity-question") {
			return "Answered the question";
		} else if (coinRecord.key == "journal-activity-review") {
			return "Wrote the review";
		}
		return FeedbackFormatter.formatSimple(coinRecord.reason);
	}
	showCoinTable() {
		$(this.refs.coinTable).show(300);
	}
	renderCoinTable(f_height,s_height) {

		var totalCoinsEarned = 0;
		var coinRows = _.map(this.props.coinRecords, function(coinRecord) {
			totalCoinsEarned += coinRecord.change;
			return (
				<tr key={ coinRecord.id }>
					<td className="subCoins">
						<CoinDisplay coins={ coinRecord.change } height={ f_height } />
					</td>
					<td>
						{ this.getShortReasonText(coinRecord) }
					</td>
				</tr>
			);
		}.bind(this));
		
		var totalCoinsRow = (
			<tr className="totalCoinsRow" key={ Math.random() }>
				<td>
					<CoinDisplay coins={ totalCoinsEarned } height={ s_height } />
				</td>
				<td>
					Total
				</td>
			</tr>
		);

		return (<table className="coinTable">
					<tbody>
						{ coinRows }
						{ totalCoinsRow }
					</tbody>
				</table>)
	}

	render() {

		// did they receive coins for anything other than addressing feedback?
		var nonFeedbackCoinRecords = _.filter(this.props.coinRecords, function(coinRecord) {
			return !coinRecord.key.includes("addressed-feedback");
		})
		// if they didn't, show the disclaimer
		if (nonFeedbackCoinRecords.length == 0) {
			if (this.props.coinRecords.length > 0) {
				// if there happen to be feedback coin records, tell them the day
				var dayOfMax = $wr.formatDate(this.props.coinRecords[0].created_at);
			} else {
				// otherwise, it's not worth figuring out what day this is
				var dayOfMax = "this day";
			}
			var coinMaxDisclaimer = (
				<p className="coinMaxDisclaimer">
					Note: You already earned the max coins for { this.props.subjectNoun } for { dayOfMax }.
				</p>
			);
		}
		var modalClass = "coinDetailsModal"
		if (this.props.subjectNoun == "quizzes" && this.props.evaluation && this.props.evaluation.autograder_version >= "v3-beta") {
			var coinTable = (
				 <div className="hiddenElement" ref="coinTable">
				 	{ this.renderCoinTable(15,18) }
					{ coinMaxDisclaimer }
				 </div>
			)
			modalClass += " fullSize"
			var headerText = "Quiz Details"
			var analysis = <QuizAnalysisDisplay 
								delay={600} 
								quiz={this.props.subject} 
								showCoinTable={this.showCoinTable.bind(this)}/>
		} else {
			modalClass += " smallSize"
			var headerText = "Coins Earned"
			var coinTable = (
				 <div>
				 	{ this.renderCoinTable(22,30) }
					{ coinMaxDisclaimer }
				 </div>
			)
		}
		return (
			<Modal className={ modalClass } ref="modal" headerText={ headerText } onHide={this.reFrame}>
				<div className="innerWrap">
					<div className="clearfix">
						{ analysis }
						{ coinTable }
					</div>
				</div>
			</Modal>
		);
	}
};

CoinDetailsModal.propTypes = StrictPropTypes({
	// gold records to display
	coinRecords: PropTypes.array.isRequired,

	subjectID: PropTypes.number,
	subject: PropTypes.object,
	evaluation: PropTypes.object,
	
	// quizzes, answers, reviews
	subjectNoun: PropTypes.string.isRequired,


});

module.exports = CoinDetailsModal;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/CoinDetailsModal.js